<template>
  <vxe-grid
    ref="table"
    size="mini"
    resizable
    auto-resize
    highlight-hover-row
    :height="483"
    :loading="loading"
    :data="tableData"
    :columns="tableColumns"
    :toolbar-config="tableToolbar"
    :checkbox-config="{ highlight: true, reserve: true, trigger: 'row' }"
    @checkbox-change="checkboxChange"
    @checkbox-all="checkboxChange"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
  },
}
</script>
